import { type TooltipStateReturn, useTooltipState } from 'reakit';

export type Placement =
  | 'auto-start'
  | 'auto'
  | 'auto-end'
  | 'top-start'
  | 'top'
  | 'top-end'
  | 'right-start'
  | 'right'
  | 'right-end'
  | 'bottom-end'
  | 'bottom'
  | 'bottom-start'
  | 'left-end'
  | 'left'
  | 'left-start';

export interface TooltipOptions {
  animated?: boolean | number;
  id: string | number;
  placement?: Placement;
  visible?: boolean;
  withArrow?: boolean;
}

export function useAlwaysVisibleTooltip(initialState: TooltipOptions, isVisible: boolean): TooltipStateReturn {
  const tooltip = useTooltipState({
    ...initialState,
    baseId: initialState.id.toString(),
    visible: isVisible,
  });
  return { ...tooltip, visible: isVisible };
}
